//引入外部模組
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import {LazyLoad} from '@/lazyload';




//Banner-首頁
class IndexBanner {
  constructor() {
    this.window  = $(window);
    this.slideEl = $('#indexBanner');

    //輪播圖片
    this.slide = this.slideEl.find('.slide');
    this.pb    = this.slideEl.find('.prevBtn');
    this.nb    = this.slideEl.find('.nextBtn');
    this.ds    = this.slideEl.find('.dots');
  }
  sliderModule() {
    //輪播圖片
    let slide = new Swiper(this.slide, {
      navigation: {
        prevEl: this.pb,
        nextEl: this.nb
      },
      pagination: {
        el            : this.ds,
        clickable     : true,
        dynamicBullets: true,
      },
      autoplay: {
        delay: 3000
      },
      effect        : 'coverflow',
      grabCursor    : true,
      loop          : true,
      slidesPerView : 1,
      spaceBetween  : 0,
      autoHeight    : true,
      observer      : true,
      observeParents: true,
      roundLengths  : true
    });
    
    
    //滑入本區塊開啟 & 關閉自動播放
    let rwdResize = () => {
      slide.autoplay.start();
      if(window.matchMedia('(max-width: 1023px)').matches){
        this.slide.off('mouseover');
        this.slide.off('mouseout');
      }else{
        this.slide.on('mouseover', () => {
          slide.autoplay.stop();
        });
        this.slide.on('mouseout', () => {
          slide.autoplay.start();
        });
      }
    }
    rwdResize();
    this.window.on('resize', rwdResize);
  }
}




//物件-首頁
class IndexObjsSlider {
  constructor() {
    //優質物件
    this.itemsNew    = $('#indexObjsNew');
    //中古降價屋
    this.itemsOnSale = $('#indexObjsOnSale');
    //實境環景看屋
    this.itemsVR720  = $('#indexObjsVR720');
  }
  objsSlider(slideEl) {
    //輪播物件
    let slide = new Swiper(slideEl.find('.slide'), {
      navigation: {
        prevEl: slideEl.find('.prevBtn'),
        nextEl: slideEl.find('.nextBtn')
      },
      pagination: {
        el            : slideEl.find('.dots'),
        clickable     : true,
        dynamicBullets: true,
      },
      grabCursor          : true,
      loop                : true,
      loopAdditionalSlides: 4,
      slidesPerView       : 4,
      spaceBetween        : 0,
      autoHeight          : true,
      observer            : true,
      observeParents      : true,
      on: {
        slideChangeTransitionEnd: () => {
          //圖片延遲載入並裁切
          let lazyLoad = new LazyLoad;
          lazyLoad.imgLoad();
        }
      },
      breakpoints: {
        1279: {
          slidesPerView       : 3,
          loopAdditionalSlides: 3
        },
        1023: {
          slidesPerView       : 2,
          loopAdditionalSlides: 2
        },
        600: {
          slidesPerView       : 1,
          loopAdditionalSlides: 1
        }
      }
    });
  }
  sliderModule() {
    //優質物件
    this.objsSlider(this.itemsNew);
    //中古降價屋
    this.objsSlider(this.itemsOnSale);
    //實境環景看屋
    this.objsSlider(this.itemsVR720);
  }
}




//物件-內頁
class ObjsBannerImg {
  constructor() {
    this.slideEl   = $('#objRealtyDetail');
    this.banner    = this.slideEl.find('.slideBanner');
    // this.thumbs    = this.slideEl.find('.slideThumbs');
    // this.imgT      = this.slideEl.find('.imgT');
    // this.thumbsBtn = this.imgT.find('.thumbsBtn');

    //輪播圖片
    this.pb = this.slideEl.find('.prevBtn');
    this.nb = this.slideEl.find('.nextBtn');
  }
  //開啟關閉小圖列表
  /*
  thumbsCtrl() {
    this.imgT.hover(() => {
      this.imgT.addClass('active');
    }, () => {
      this.imgT.removeClass('active');
    });
    this.thumbsBtn.on('click', () => {
      if(this.imgT.is('.active')){
        this.imgT.removeClass('active');
      }else{
        this.imgT.addClass('active');
      }
    });
  }
  */
  sliderModule() {
    //開啟關閉小圖列表
    // this.thumbsCtrl();

    //大圖
    let slideB = new Swiper(this.banner, {
      navigation: {
        prevEl: this.pb,
        nextEl: this.nb
      },
      grabCursor    : true,
      spaceBetween  : 0,
      observer      : true,
      observeParents: true,
      roundLengths  : true,
      on: {
        init: () => {
          //圖片延遲載入
          let lazyLoad = new LazyLoad;
          lazyLoad.noImgCropLoad();
        },
        slideChangeTransitionEnd: () => {
          //圖片延遲載入
          let lazyLoad = new LazyLoad;
          lazyLoad.noImgCropLoad();
          // 目前頁數 & 總數
          // this.thumbsBtn.find('span').html((slideT.realIndex + 1) + ' / ' + slideT.slides.length);
        }
      }
    });

    //小圖列表
    /*
    let slideT = new Swiper(this.thumbs, {
      grabCursor         : true,
      slidesPerView      : 5,
      spaceBetween       : 0,
      centeredSlides     : true,
      slideToClickedSlide: true,
      observer           : true,
      observeParents     : true,
      roundLengths       : true,
      on: {
        init: () => {
          //圖片延遲載入並裁切
          let lazyLoad = new LazyLoad;
          lazyLoad.imgLoad();
        },
        slideChangeTransitionEnd: () => {
          //圖片延遲載入並裁切
          let lazyLoad = new LazyLoad;
          lazyLoad.imgLoad();
          //目前頁數 & 總數
          this.thumbsBtn.find('span').html((slideT.realIndex + 1) + ' / ' + slideT.slides.length);
        }
      }
    });
    

    //目前頁數 & 總數 (初始化)
    this.thumbsBtn.find('span').html((slideT.realIndex + 1) + ' / ' + slideT.slides.length);

    //同步控制
    slideB.controller.control = slideT;
    slideT.controller.control = slideB;
    */
  }
}




//Footer Ads
class FooterAds {
  constructor() {
    this.window  = $(window);
    this.slideEl = $('#footerAds');

    //輪播圖
    this.slide = this.slideEl.find('.slide');
    this.pb    = this.slideEl.find('.prevBtn');
    this.nb    = this.slideEl.find('.nextBtn');
    this.ds    = this.slideEl.find('.dots');
  }
  sliderModule() {
    //輪播圖片
    let slide = new Swiper(this.slide, {
      navigation: {
        prevEl: this.pb,
        nextEl: this.nb
      },
      pagination: {
        el            : this.ds,
        clickable     : true,
        dynamicBullets: true,
      },
      grabCursor          : true,
      loop                : true,
      loopAdditionalSlides: 4,
      autoplay: {
        delay: 3000
      },
      slidesPerView : 4,
      spaceBetween  : 0,
      autoHeight    : true,
      observer      : true,
      observeParents: true,
      roundLengths  : true,
      breakpoints: {
        1279: {
          slidesPerView       : 3,
          loopAdditionalSlides: 3
        },
        1023: {
          slidesPerView       : 2,
          loopAdditionalSlides: 2
        },
        600: {
          slidesPerView       : 1,
          loopAdditionalSlides: 1
        }
      }
    });

    //滑入本區塊開啟 & 關閉自動播放
    let rwdResize = () => {
      slide.autoplay.start();
      if(window.matchMedia('(max-width: 1023px)').matches){
        this.slide.off('mouseover');
        this.slide.off('mouseout');
      }else{
        this.slide.on('mouseover', () => {
          slide.autoplay.stop();
        });
        this.slide.on('mouseout', () => {
          slide.autoplay.start();
        });
      }
    }
    rwdResize();
    this.window.on('resize', rwdResize);
  }
}




//輸出
export {IndexBanner, IndexObjsSlider, ObjsBannerImg, FooterAds};


// WEBPACK FOOTER //
// ./js_new/slider.js